import { render, staticRenderFns } from "./SelectCompany.vue?vue&type=template&id=40b903a7&"
import script from "./SelectCompany.vue?vue&type=script&lang=ts&"
export * from "./SelectCompany.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports